import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Blog.module.css';
import dadosNoticias from '../../BlogJson/db.json'; 
import blogImg1 from './img/capas/blogImg1.jpg';
import blogImg2 from './img/capas/blogImg2.png';
import blogImg3 from './img/capas/blogImg3.png';
import blogIMg4 from './img/capas/blogImg4.jpg';
import blogImg5 from './img/capas/blogImg5.jpg';
import blogImg6 from './img/capas/blogImg6.png';


function Blog() {
  const [noticias, setNoticias] = useState([]);

  const capaNoticias = [
    { id: 1, capa: blogImg1 },
    { id: 2, capa: blogImg2 },
    { id: 3, capa: blogImg3},
    { id: 4, capa: blogIMg4 },
    { id: 5, capa: blogImg5 },
    { id: 6, capa: blogImg6 }
  ];

  useEffect(() => {
    const arrayNoticias = dadosNoticias.noticias;
    const dadosReversos = [...arrayNoticias].reverse();
    setNoticias(dadosReversos);
  }, []);

  return (
    <div className={styles.paginaBlog}>
      
      <section className={styles.bannerBlog}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Nosso Blog</h1>
            <p>Conhecimento especializado para impulsionar o seu negócio.</p>
          </div>
        </div>
      </section>

      <section className={`${styles.secaoConteudo} ${styles.bgClaro}`}>
        <div className={styles.container}>
          
          <div className={styles.introBlog}>
            <h2>Portal de Notícias: Contabilidade & RH</h2>
            <p>Acompanhe as últimas atualizações, obrigações legais e estratégias de gestão do mercado corporativo. Nossa equipe traz análises aprofundadas e orientações precisas para garantir a conformidade e o crescimento sustentável da sua empresa nas áreas contábil, fiscal e de recursos humanos.</p>
          </div>

          <div className={styles.blogGrid}>
            {noticias.map((noticia) => {
              
              const capaCorrespondente = capaNoticias.find((item) => item.id === noticia.id);
              const urlDaCapa = capaCorrespondente ? capaCorrespondente.capa : "";

              return (
                <article key={noticia.id} className={styles.blogCard}>
                  
                  <div className={styles.cardImagemWrapper}>
                    <img src={urlDaCapa} alt={noticia.titulo} className={styles.cardImagem} />
                    <span className={styles.categoriaTag}>{noticia.tag}</span>
                  </div>

                  <div className={styles.cardCorpo}>
                    <span className={styles.dataPublicacao}>{noticia.data}</span>
                    <h3>{noticia.titulo}</h3>
                    <p>{noticia.subtitulo}</p>
                    
                    <Link to={`/blog/${noticia.id}`} className={styles.linkArtigo}>
                      Ler Artigo Completo
                    </Link>
                  </div>

                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blog;